<template>
  <div id="page-dimension-edit">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <div>
        <h5>
          {{ $t('pages.dimension.editDimension') }}:
          <strong>{{ DimensionModule.dimension.id }}</strong>
        </h5>
      </div>
      <div>
        <router-link
            class="btn btn-outline-primary mb-3"
            :to="{ name: 'dimension-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudDimension
        :dimension="DimensionModule.dimension"
        :selected-category="getSelectedCategory"
        :id="DimensionModule.dimension.id"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchDimension', this.$route.params.id)
  },
  updated() {
    this.hideLoader()
  },
  computed: {
    getSelectedCategory() {
      return (
          this.DimensionModule.dimension
          && this.DimensionModule.dimension.category)
          ? this.DimensionModule.dimension.category.id
          : null
    },
    ...mapState(['DimensionModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudDimension: () => import('@/components/pages/dimension/FormCrudDimension')
  }
}
</script>

<style scoped>

</style>
